//@flow

import React from "react"
import { FormattedMessage } from "react-intl"
import { Cubic, TweenMax } from "gsap"

import SVGLoader from "../../../UI/SVGLoader"
import {
  ContentContainer,
  Titles,
  TitleText,
  TitleDescription,
  DriveThru,
  Midground,
  Background
} from "./UI"

import idlingDriveThru from "./idlingDriveThru.svg"
import idlingClouds from "./idlingClouds.svg"
import idlingCity from "./idlingCity.svg"

type Props = {}

class IdlingView extends React.Component<Props> {
  introText: HTMLElement[]
  container: ?HTMLElement
  monster: ?HTMLElement
  city: ?HTMLElement
  clouds: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.introText = []
    this.container = null
    this.monster = null
    this.city = null
    this.clouds = null
  }

  componentDidMount() {
    this.showIntroText()
    this.showScene()
  }

  showIntroText = () => {
    const intro = this.introText.filter(el => el !== null)
    TweenMax.set(intro, { y: "40", opacity: 0 })
    TweenMax.staggerTo(
      intro,
      0.5,
      { y: "0", opacity: 1, ease: Cubic.easeOut, delay: 0.5 },
      0.2
    )
  }

  showScene = () => {
    TweenMax.set(this.city, { opacity: 0, x: -100 })
    TweenMax.set(this.monster, { opacity: 0, x: -250 })
    TweenMax.set(this.clouds, { opacity: 0, x: -50 })
    TweenMax.staggerTo(
      [this.monster, this.city, this.clouds],
      1,
      {
        opacity: 1,
        ease: Cubic.easeOut,
        delay: 1
      },
      0.1
    )
    TweenMax.to(this.clouds, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
    TweenMax.to(this.monster, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
    TweenMax.to(this.city, 3, { x: 0, ease: Cubic.easeOut, delay: 1 })
  }

  render() {
    return (
      <ContentContainer innerRef={el => (this.container = el)}>
        <Titles>
          <TitleText innerRef={el => this.introText.push(el)}>
            <FormattedMessage id="kiosk.commit.idling.title" />
          </TitleText>
          <TitleDescription innerRef={el => this.introText.push(el)}>
            <FormattedMessage id="kiosk.commit.idling.intro" />
          </TitleDescription>
        </Titles>
        <DriveThru innerRef={el => (this.monster = el)}>
          <SVGLoader path={idlingDriveThru} height="100%" width="100%" />
        </DriveThru>
        <Midground innerRef={el => (this.city = el)}>
          <SVGLoader path={idlingCity} height="100%" width="100%" />
        </Midground>
        <Background innerRef={el => (this.clouds = el)}>
          <SVGLoader path={idlingClouds} height="100%" width="100%" />
        </Background>
      </ContentContainer>
    )
  }
}

export default IdlingView



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Idling/index.js